<template>
  <label class="p_form_checkbox">
    <span :for="id" :class="[lclass, dameClassReadOnly]">{{ label }}</span>
    <input :id="id" type="checkbox" @change="change" :checked="isChecked" :disabled="readonly" />
    <span class="p_form_check"></span>
  </label>
</template>
<script lang="ts">
// En este compononente es complicado poder poner una variente
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export class PFormCheckBox extends Vue {
  @Model("intput") readonly checked!: any;
  @Watch("checked")
  onChangeChecked(): void {
    this.isCheckedFun();
  }
  @Prop({ required: true }) id!: string;
  @Prop({ required: false, default: true }) value!: any;
  @Prop({ required: false, default: false }) unchecked_value!: any;
  @Prop({ required: false }) label!: string;
  @Prop({ required: false, default: "p_form_checkbox_label" }) lclass!: string;
  @Prop({ required: false, default: false }) readonly!: boolean;

  public isChecked: boolean;
  public defaultCheked: boolean;
  public mostrarLabel: boolean;
  constructor() {
    super();
    this.isChecked = false;
    this.defaultCheked = false;
    this.mostrarLabel = false;
  }

  change(): void {
    this.isChecked = !this.isChecked;
    if (this.isChecked) {
      this.$emit("intput", this.value);
      this.$emit("change", this.value);
    } else {
      this.$emit("intput", this.unchecked_value);
      this.$emit("change", this.unchecked_value);
    }
  }
  isCheckedFun(): void {
    if (this.value === this.checked) {
      this.defaultCheked = true;
      this.isChecked = true;
    } else {
      this.defaultCheked = false;
      this.isChecked = false;
    }
  }

  mounted(): void {
    if (this.label === undefined) {
      this.mostrarLabel = false;
    } else {
      this.mostrarLabel = true;
    }
    this.isCheckedFun();
  }
  get dameClassReadOnly(): string {
    if (this.readonly) {
      return "sololectura";
    } else {
      return "";
    }
  }
}
export default PFormCheckBox;
</script>
<style lang="scss" scoped>
@import "@/assets/scss/prosegur/color";
/* custom checkbox */
.p_form_checkbox {
  display: flex;

  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: left;

  align-items: center;
  position: relative;
}

/* hide the browser's default checkbox */
.p_form_checkbox input,
.p_form_check {
  height: 16px;
  width: 16px;
}

.p_form_checkbox input {
  opacity: 0;
  cursor: pointer;
}

/* create custom checkbox */
.p_form_check {
  position: absolute;
  background-color: var(--blanco-prosegur);
  border: 1px solid #cdcdcd;
  border-radius: 0.25rem;
}

/* on mouse-over, add border color */
.p_form_checkbox:hover input ~ .p_form_check {
  border: 2px solid var(--amarillo-prosegur);
}

/* add background color when the checkbox is checked */
.p_form_checkbox input:checked ~ .p_form_check {
  background-color: var(--amarillo-prosegur);
  border: none;
}

/* create the checkmark and hide when not checked */
.p_form_check:after {
  content: "";
  position: absolute;
  display: none;
}

/* show the checkmark when checked */
.p_form_checkbox input:checked ~ .p_form_check:after {
  display: block;
}

/* checkmark style */
.p_form_checkbox .p_form_check:after {
  left: 6px;
  top: 3px;
  width: 5px;
  height: 7px;
  border: solid var(--blanco-prosegur);
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.p_form_checkbox_label {
  cursor: pointer;
  -o-object-fit: contain;
  object-fit: contain;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  color: #4c4c4c;
  padding-left: 25px;
  padding-top: 2px;
}
.sololectura {
  cursor: no-drop;
  color: #ddd9d9;
}
</style>
